import type { SimilarPartResult } from '@frontend/api';

export const OPEN_SIMILAR_COMPONENTS_MODAL =
  'modules/quotes/modals/OPEN_SIMILAR_COMPONENTS_MODAL';
export const CLOSE_SIMILAR_COMPONENTS_MODAL =
  'modules/quotes/modals/CLOSE_SIMILAR_COMPONENTS_MODAL';

export type OpenSimilarComponentsModalAction = {
  type: typeof OPEN_SIMILAR_COMPONENTS_MODAL;
  payload: {
    componentId: number;
    similarParts: SimilarPartResult[];
  };
};

export type CloseSimilarComponentsModalAction = {
  type: typeof CLOSE_SIMILAR_COMPONENTS_MODAL;
};

export type SimilarComponentsModalAction =
  | OpenSimilarComponentsModalAction
  | CloseSimilarComponentsModalAction;

export const similarComponentsModal = {
  open: ({
    componentId,
    similarParts,
  }: {
    componentId: number;
    similarParts: SimilarPartResult[];
  }): OpenSimilarComponentsModalAction => ({
    type: OPEN_SIMILAR_COMPONENTS_MODAL,
    payload: { componentId, similarParts },
  }),
  close: (): CloseSimilarComponentsModalAction => ({
    type: CLOSE_SIMILAR_COMPONENTS_MODAL,
  }),
};
